import cn from "classnames"

import styles from "../HeaderScanHistoryTab.module.scss"

export const Legend = ({
  items,
  classes = {}
}: {
  items: { color: string; label: string | React.ReactNode }[]
  classes?: { container?: string; item?: string; text?: string }
}) => (
  <div className={cn(styles.legend, classes.container)}>
    {items.map(({ color, label }) => (
      <div key={color} className={cn(styles.legendItem, classes.item)}>
        <span style={{ backgroundColor: color }} />
        <span className={classes.text}>{label}</span>
      </div>
    ))}
  </div>
)
